module.exports = __webpack_public_path__ + "static/media/webcam.94c06a1a.svg";